import React from 'react';

const DashboardSection = ({ title, description, icon: IconComponent, children, action }) => (
  <section className="space-y-4">
    <div className="flex items-start justify-between gap-4">
      <div>
        <h2 className="text-lg font-semibold text-foreground flex items-center gap-2">
          {IconComponent}
          {title}
        </h2>
        {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
      </div>
      {action}
    </div>
    {children}
  </section>
);

export default DashboardSection;
